import { Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { forbidden, notFound, RouteConfig } from '.';
import RouteWithPageTitle from './RouteWithPageTitle';
import { useAccountAuthenticate } from './useAccountAuthenticate';

const ProtectedAccountRoute = (props: RouteConfig) => {
  const {
    isAccountAuthenticated,
    redirectToForbidden,
    redirectToNotFound,
    redirectToUpgradeBlockedForbidden,
    accountAuthenticationError,
    retryAccountAuthentication,
  } = useAccountAuthenticate(props);
  if (isAccountAuthenticated) {
    return <RouteWithPageTitle {...props} />;
  }
  if (redirectToUpgradeBlockedForbidden) {
    return <Navigate to={`${forbidden.path}?upgradeBlocked=true`} replace />;
  }
  if (redirectToForbidden) {
    return <Navigate to={forbidden.path} replace />;
  }
  if (redirectToNotFound) {
    return <Navigate to={notFound.path} replace />;
  }
  if (accountAuthenticationError) {
    return (
      <Box
        role="alert"
        display="flex"
        minHeight="60vh"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={2}
        px={3}
        textAlign="center"
      >
        <Typography variant="h5">
          <FormattedMessage id="account_verification.error.title" />
        </Typography>
        <Typography color="text.secondary">
          <FormattedMessage id="account_verification.error.description" />
        </Typography>
        <Button variant="contained" onClick={retryAccountAuthentication}>
          <FormattedMessage id="account_verification.error.retry" />
        </Button>
      </Box>
    );
  }
  return <></>;
};

export default ProtectedAccountRoute;
